<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-6 offset-md-3">
                    <div
                        class="col-12 mt-5 mb-4 d-flex justify-content-md-center align-items-center"
                    >
                        <h2 class="color--purple-2 heading-spacing--large">
                            Wachtwoord vergeten
                        </h2>
                    </div>

                    <slot name="introductionText"></slot>

                    <form action="" class="row justify-content-md-center">
                        <div class="col-12 col-lg-10 mb-4">
                            <label
                                for="emailaddress"
                                class="col-12 label--default"
                                >E-mailadres</label
                            >
                            <input
                                id="emailaddress"
                                v-model="emailaddress"
                                class="input--default input--rounded"
                                placeholder="gebruiker@verwonderomdehoek.nl"
                                rules="required"
                                type="text"
                            />
                        </div>

                        <div
                            v-if="!processing && !success"
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <button class="col-8 btn btn--blue-7" @click="send">
                                <span>
                                    Verstuur
                                    <i class="fas fa-arrow-right ml-2"></i>
                                </span>
                            </button>
                        </div>
                        <div
                            v-else
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <span v-if="!success">Een moment geduld...</span>
                        </div>

                        <div
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <p>{{ statusMessage }}</p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {},
    data() {
        return {
            emailaddress: '',
            response: '',
            statusMessage: '',
            processing: false,
            success: false
        };
    },
    mounted() {},
    methods: {
        send(e) {
            e.preventDefault();
            this.statusMessage = '';
            this.processing = true;
            axios
                .post('/clientdashboard/account/forgotpassword/get', {
                    email: this.emailaddress
                })
                .then(response => {
                    this.response = response;

                    if (response.data.success) {
                        this.statusMessage = response.data.successMsg;
                        this.success = true;
                    } else {
                        this.statusMessage = response.data.errorMsg;
                    }
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                })
                .finally(() => {
                    this.processing = false;
                });
        }
    }
};
</script>
<style></style>
